<template>
  <div class="field no-select">
    <label
      v-if="title"
      class="mb-2 label no-select"
    >
      <h3>{{ title }}</h3>
    </label>
    <div class="custom-control custom-checkbox no-select pt-1">
      <input
        :id="name"
        v-model="model"
        type="checkbox"
        class="custom-control-input"
        :disabled="isDisabled"
      />
      <label
        class="custom-control-label no-select"
        :for="name"
      >
        {{ label }}
      </label>
      <p
        v-if="hasHelpText"
        class="help-text"
        v-html="finalHelpText"
      ></p>
    </div>
  </div>
</template>

<script>
import commonProperties from './common-properties';

export default {
  name: 'Checkbox',
  mixins: [commonProperties],
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-weight: $lb-medium;
  font-size: $size-normal;
  line-height: 1.5;
  color: $dark;
}
.custom-checkbox {
  padding-left: 24px;

  .custom-control-label:hover,
  .custom-control-input:focus ~ .custom-control-label {
    &::before {
      border-color: $crm-blue-primary;
    }
  }

  .custom-control-label {
    cursor: pointer;

    &::before {
      border-radius: 4px;
      height: 16px;
      width: 16px;
      top: 2px;
      left: -24px;
    }

    &::after {
      background-size: 60% !important;
      height: 16px !important;
      width: 16px !important;
      top: 2px;
      left: -24px;
    }
  }
}
</style>
